module.exports = __webpack_public_path__ + "static/media/artist-chrissy-roshak.59972155.svg";